import { useCallback, useRef } from 'react'

import ListenToKeyboard from 'components/ListenToKeyboard'
import { Button } from 'shared/ui'
import { formData } from 'util/forms'
import { convertFromDotToNested } from 'util/objects'

export default ({ children, onCancel, onSave }) => {
  const formRef = useRef()
  const onSubmit = useCallback(
    event => {
      event.preventDefault()
      onSave(convertFromDotToNested(formData(formRef.current)))
      onCancel()
    },
    [onCancel, onSave]
  )
  return (
    <form className="ui form" onSubmit={onSubmit} ref={formRef}>
      <ListenToKeyboard onCmdEnter={onSubmit} />
      {children}
      <div className="buttons">
        <Button primary size="small" type="submit">
          Save
        </Button>
        {onCancel && (
          <Button as="div" basic onClick={onCancel} size="small">
            Cancel
          </Button>
        )}
      </div>
    </form>
  )
}
